import { ReactElement } from "react";
import css from "../styles/css.module.scss";
import cn from "classnames";
import { IMetricBlock } from "../pdf/pdfExportHelpers";


interface MetricBlockProps extends IMetricBlock {
    titleAction?: ReactElement;
}

export default function MetricBlock({
    title,
    isSmallTitle = false,
    values,
    text,
    titleAction,
}: MetricBlockProps): ReactElement {
    const titleElement = <h2 className={cn(css.title, isSmallTitle && css.titleSmall)}>{title}</h2>;

    return (
        <div className={css.metricBlock}>
            {titleAction ?
                <div className={css.titleRow}>
                    {titleElement}
                    {titleAction}
                </div>
                : titleElement
            }
            <div className={css.metricBlockValues}>
                {values && values.map((v, i) => {
                    return (
                        <div key={i}>
                            <div className={css.metricBlockTopLabel}>{v.topLabel}</div>
                            <div className={css.metricBlockValue}>{v.value}</div>
                            <div className={css.metricBlockBottomLabel}>{v.bottomLabel}</div>
                        </div>
                    );
                })}
            </div>
            <div className={css.metricBlockText}>{text}</div>
        </div>
    );
}
